import { render, staticRenderFns } from "./PyqList.vue?vue&type=template&id=4d5ea656&scoped=true"
import script from "./PyqList.vue?vue&type=script&lang=js"
export * from "./PyqList.vue?vue&type=script&lang=js"
import style0 from "./PyqList.vue?vue&type=style&index=0&id=4d5ea656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5ea656",
  null
  
)

export default component.exports